import { PERMISSIONS } from "../../../../auth/permissions";
import { ContentBase } from "../ContentBase";

export class TextContent extends ContentBase {
  constructor(
    private text: string,
    styles = "",
    permissions: PERMISSIONS[] = [],
    condition = () => true,
  ) {
    super(styles, permissions, condition);
  }

  protected generateContentElement(): JSX.Element {
    return (
      <span className={this.styles} data-cy={this.testAttribute}>
        {this.text}
      </span>
    );
  }

  clone(): TextContent {
    return new TextContent(
      this.text,
      this.styles,
      this.permissions,
      this.condition,
    );
  }
}
